import { render } from "./LotteryExplain.vue?vue&type=template&id=b883bd98&scoped=true"
import script from "./LotteryExplain.vue?vue&type=script&lang=js"
export * from "./LotteryExplain.vue?vue&type=script&lang=js"

import "./LotteryExplain.vue?vue&type=style&index=0&id=b883bd98&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b883bd98"]])

export default __exports__